import React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import FolderIcon from "@mui/icons-material/Folder";
import { handleUnnestedLevelClick } from "./SitesPageUtils/handleUnnestedLevelClick";
import { CameraIcon } from "../../../common/CameraIcon";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import { useSitesPageStore } from "./sitesPageStore/sitesPageStore";

interface UnnestedListItemProps {
  arrayItem: any;
  setPage: any;
  setCurrentTitle: any;
  indentNumber: number;
  setRenderedRows: any;
  setPageLoading: any;
  navigate: any;
  setSiteBreadcrumbs: any;
  navBarCollapsed: boolean;
  setSelected: any;
  setSelectedGroupListName: any;
  setEditableGroupSelected: any;
}

export const UnnestedListItem: React.FC<UnnestedListItemProps> = ({
  arrayItem,
  setPage,
  setCurrentTitle,
  indentNumber,
  setRenderedRows,
  setPageLoading,
  navigate,
  setSiteBreadcrumbs,
  navBarCollapsed,
  setSelected,
  setSelectedGroupListName,
  setEditableGroupSelected,
}) => {
  const {
    getSelectedGroupCounts,
    selectedGroupCounts,
    fetchingSelectedGroupCounts,
  } = useSitesPageStore();

  let tooltipContent = null;

  if (fetchingSelectedGroupCounts) {
    tooltipContent = <div>Loading counts...</div>;
  } else if (selectedGroupCounts && selectedGroupCounts.id === arrayItem.id) {
    const hasSitesCount = selectedGroupCounts.sites !== undefined;
    if (hasSitesCount) {
      tooltipContent = (
        <div>
          <div>{arrayItem.name}</div>
          <div>{`Sub Groups: ${selectedGroupCounts.sub_groups}`}</div>
          <div>{`Sites: ${selectedGroupCounts.sites}`}</div>
        </div>
      );
    }
    // If no sites count, tooltipContent remains null, and the tooltip will not be shown.
  }

  return (
    <>
      {arrayItem.parent_account ? (
        <Tooltip
          title={tooltipContent}
          placement="right"
          onOpen={() => {
            getSelectedGroupCounts(navigate, arrayItem.id);
          }}
        >
          <span>
            <ListItemButton
              sx={{ pl: indentNumber }}
              onClick={() => {
                handleUnnestedLevelClick(
                  setPage,
                  setCurrentTitle,
                  arrayItem.name,
                  arrayItem.id,
                  setRenderedRows,
                  setPageLoading,
                  navigate,
                  setSiteBreadcrumbs,
                  setSelected,
                  true,
                  setSelectedGroupListName,
                  setEditableGroupSelected
                );
              }}
            >
              <ListItemIcon>
                <FolderIcon className="ml-[15px]" />
              </ListItemIcon>
              <ListItemText
                primary={`${arrayItem.name}`}
                primaryTypographyProps={{
                  fontSize: 14,
                  fontFamily: "Mulish",
                }}
              />
            </ListItemButton>
          </span>
        </Tooltip>
      ) : (
        <ListItemButton
          sx={{ pl: indentNumber }}
          onClick={() => {
            handleUnnestedLevelClick(
              setPage,
              setCurrentTitle,
              arrayItem.name,
              arrayItem.id,
              setRenderedRows,
              setPageLoading,
              navigate,
              setSiteBreadcrumbs,
              setSelected,
              true,
              setSelectedGroupListName,
              setEditableGroupSelected
            );
          }}
        >
          <ListItemIcon>
            <CameraIcon />
          </ListItemIcon>
          <ListItemText
            primary={`${arrayItem.name}`}
            primaryTypographyProps={{
              fontSize: 14,
              fontFamily: "Mulish",
            }}
          />
        </ListItemButton>
      )}
    </>
  );
};
